import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';

import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';

import { AddressDetails, OwnerDetails } from '@store';
import { OwnershipType } from '@vi-iot/client';

import { SrcVdzFormService } from './src-vdz-form.service';
import { VdzFormHelper } from './src-vdz-form.helper';
import { ViToastService } from '@vi-iot/ui/index';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-src-vdz-form-overlay',
  templateUrl: './src-vdz-form-overlay.component.html',
  styleUrls: ['./src-vdz-form-overlay.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SrcVdzFormOverlayComponent implements OnInit, OnDestroy {
  vdzFormStatus = VdzFormHelper.VdzFormStatus;
  status$ = new BehaviorSubject<VdzFormHelper.VdzFormStatus>(VdzFormHelper.VdzFormStatus.Loading);
  pdfUrl: string;
  ngUnsubscribe$: Subject<void> = new Subject();
  ownershipType: OwnershipType;
  address$: Observable<AddressDetails>;
  owner$: Observable<OwnerDetails>;

  constructor(
    private srcVdzFormService: SrcVdzFormService,
    private toastService: ViToastService,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.srcVdzFormService
      .processPdfFile()
      .pipe(take(1), takeUntil(this.ngUnsubscribe$))
      .subscribe({
        next: (path) => {
          this.pdfUrl = path;
          this.status$.next(VdzFormHelper.VdzFormStatus.Ready);
        },
        error: () => {
          this.toastService.error({
            message: this.translate.instant('+INSTALLATIONS.SRC.VDZ_FORM.LOADING.ERROR'),
          });
          this.status$.next(VdzFormHelper.VdzFormStatus.Error);
        },
      });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }

  download(): void {
    const link = document.createElement('a');
    link.href = this.pdfUrl;
    link.download = VdzFormHelper.downloadFilename;
    link.click();
  }
}
